import * as actionTypes from "../Action/ActionTypes";
import * as actionReducer from "./ActionReducer";

const initialState = {
  dialogsFlag: {
    addOrg: false,
    addRole: false,
    editRole: false,
    addTenant: false,
    deleteOrg: false,
    deleteRole: false,
    AddOrgUser: false,
    addOrgAdmin: false,
    deleteTenant: false,
    AddTenantUser: false,
    EditTenantUser: false,
    SelectLocation: false,
    createNewContract: false,
  },
  tenantsList: [],
  Organizations: {
    error: null,
    request: null,
    response: null,
    allOrgs: null,
  },
  Organization: {
    error: null,
    request: null,
    response: null,
  },
  Tenants: {
    error: null,
    request: null,
    response: null,
  },
  AddOrg: {
    error: null,
    request: null,
    response: null,
  },
  EditOrg: {
    error: null,
    request: null,
    response: null,
  },
  AddTenant: {
    error: null,
    request: null,
    response: null,
  },

  EditTenant: {
    error: null,
    request: null,
    response: null,
  },
  OrgActivation: {
    error: null,
    request: null,
    response: null,
  },
  TenantActivation: {
    error: null,
    request: null,
    response: null,
  },
  OrganizationUser: {
    error: null,
    request: null,
    response: null,
  },
  TenantUser: {
    error: null,
    request: null,
    response: null,
  },
  Tenant: {
    error: null,
    request: null,
    response: null,
  },
  DeleteTenant: {
    error: null,
    request: null,
    response: null,
  },
  UpdateTenantUser: {
    error: null,
    request: null,
    response: null,
  },
  UpdateOrgUser: {
    error: null,
    request: null,
    response: null,
  },
  OrgPassword: {
    error: null,
    request: null,
    response: null,
  },
  TenantPassword: {
    error: null,
    request: null,
    response: null,
  },
  OtherUserToken: {
    error: null,
    request: null,
    response: null,
  },
  OrgUsage: {
    error: null,
    request: null,
    response: null,
    tenantsId: [],
    tenantsList: [],
  },
  OrgsUsage: {
    error: null,
    request: null,
    response: null,
    orgsList: [],
  },
  DownloadUsage: {
    error: null,
    request: null,
    response: null,
  },
  DownloadExcelPlan: {
    error: null,
    request: null,
    response: null,
  },
  DownloadPlan: {
    request: null,
    response: null,
    error: null,
  },
  UpdatePOC: {
    error: null,
    request: null,
    response: null,
  },
  OrgPOC: {
    error: null,
    request: null,
    response: null,
  },
  AddOrgPOC: {
    error: null,
    request: null,
    response: null,
  },
  RemoveOrgPOC: {
    error: null,
    request: null,
    response: null,
  },
  OrgAdmins: {
    error: null,
    request: null,
    response: null,
  },
  AddOrgAdmin: {
    error: null,
    request: null,
    response: null,
  },
  AllPlans: {
    error: null,
    request: null,
    response: null,
  },
  SetPlanStatus: {
    error: null,
    request: null,
    response: null,
  },
  RestorePlan: {
    error: null,
    request: null,
    response: null,
  },
  CustomSmsList: {
    error: null,
    request: null,
    response: null,
  },
  SetCustomSms: {
    error: null,
    request: null,
    response: null,
  },
  WebhookConfig: {
    error: null,
    request: null,
    response: null,
  },
  VerificationConfig: {
    error: null,
    request: null,
    response: null,
  },
  SetWebhookConfig: {
    error: null,
    request: null,
    response: null,
  },
  SetVerificationConfig: {
    error: null,
    request: null,
    response: null,
  },
  UserActivation: {
    error: null,
    request: null,
    response: null,
  },
  AddTenantUser: {
    error: null,
    request: null,
    response: null,
  },
  RoleFlags: {
    error: null,
    request: null,
    response: null,
  },
  TenantUsers: {
    error: null,
    request: null,
    response: null,
  },
  OrgRoleFlags: {
    error: null,
    request: null,
    response: null,
  },
  OrgUsers: {
    error: null,
    request: null,
    response: null,
  },
  AddOrgUser: {
    error: null,
    request: null,
    response: null,
  },
  UserOfTenant: {
    error: null,
    request: null,
    response: null,
  },
  missionReason: {
    error: null,
    request: null,
    response: null,
  },
  UpdateMissionReason: {
    error: null,
    request: null,
    response: null,
  },
  DeleteMissionReason: {
    error: null,
    request: null,
    response: null,
  },
  AddMissionReason: {
    error: null,
    request: null,
    response: null,
  },
  UserPassword: {
    error: null,
    request: null,
    response: null,
  },

  RoleOrgsList: {
    error: null,
    request: null,
    response: null,
  },

  AddRole: {
    error: null,
    request: null,
    response: null,
  },

  EditRole: {
    error: null,
    request: null,
    response: null,
  },

  DeleteRole: {
    error: null,
    request: null,
    response: null,
  },

  roleModifyActions: {
    edit: null,
    delete: null,
  },

  Roles: {
    error: null,
    request: null,
    response: null,
  },

  RoleById: {
    error: null,
    request: null,
    response: null,
  },

  AllMenu: {
    error: null,
    request: null,
    response: null,
  },

  AllAction: {
    error: null,
    request: null,
    response: null,
  },

  PlanLogs: {
    error: null,
    request: null,
    response: null,
  },

  allContracts: {
    request: null,
    response: null,
    error: null,
  },

  addContract: {
    request: null,
    response: null,
    error: null,
  },

  deleteContract: {
    request: null,
    response: null,
    error: null,
  },

  editContract: {
    request: null,
    response: null,
    error: null,
  },
  accountUsage: {
    request: null,
    response: null,
    error: null,
  },
  clonePlan: {
    request: null,
    response: null,
    error: null,
  },
  createVersion: {
    request: null,
    response: null,
    error: null,
  },
  orgsIdList: {
    request: null,
    response: null,
    error: null,
  },
};

export const SuperAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_SHOW_DIALOGS:
      return actionReducer.Dialogs(state, action);

    case actionTypes.CLEAR_STATE:
      return actionReducer.clearState(state, action, initialState);

    case actionTypes.SET_SEARCHED_ORGS:
      return actionReducer.SearchOrgs(state, action);

    case actionTypes.GET_ORGANIZATION:
      return actionReducer.getOrganization(state, action);
    case actionTypes.GET_ORGANIZATION_SUCCESS:
      return actionReducer.getOrganizationSuccess(state, action);
    case actionTypes.GET_ORGANIZATION_FAIL:
      return actionReducer.getOrganizationFail(state, action);

    case actionTypes.CLONE_PLAN:
      return actionReducer.clonePlan(state, action);
    case actionTypes.CLONE_PLAN_SUCCESS:
      return actionReducer.clonePlanSuccess(state, action);
    case actionTypes.CLONE_PLAN_FAIL:
      return actionReducer.clonePlanFail(state, action);

    case actionTypes.GET_ALL_TENANTS:
      return actionReducer.getAllTenants(state, action);
    case actionTypes.GET_ALL_TENANTS_SUCCESS:
      return actionReducer.getAllTenantsSuccess(state, action);
    case actionTypes.GET_ALL_TENANTS_FAIL:
      return actionReducer.getAllTenantsFail(state, action);

    case actionTypes.ADD_ORGANIZATION:
      return actionReducer.addOrg(state, action);
    case actionTypes.ADD_ORGANIZATION_SUCCESS:
      return actionReducer.addOrgSuccess(state, action);
    case actionTypes.ADD_ORGANIZATION_FAIL:
      return actionReducer.addOrgFail(state, action);

    case actionTypes.EDIT_ORGANIZATION:
      return actionReducer.editOrg(state, action);
    case actionTypes.EDIT_ORGANIZATION_SUCCESS:
      return actionReducer.editOrgSuccess(state, action);
    case actionTypes.EDIT_ORGANIZATION_FAIL:
      return actionReducer.editOrgFail(state, action);

    case actionTypes.ADD_TENANT:
      return actionReducer.addTenant(state, action);
    case actionTypes.ADD_TENANT_SUCCESS:
      return actionReducer.addTenantSuccess(state, action);
    case actionTypes.ADD_TENANT_FAIL:
      return actionReducer.addTenantFail(state, action);

    case actionTypes.EDIT_TENANT:
      return actionReducer.editTenant(state, action);
    case actionTypes.EDIT_TENANT_SUCCESS:
      return actionReducer.editTenantSuccess(state, action);
    case actionTypes.EDIT_TENANT_FAIL:
      return actionReducer.editTenantFail(state, action);

    case actionTypes.GET_ORGANIZATION_BY_ID:
      return actionReducer.getOrgById(state, action);
    case actionTypes.GET_ORGANIZATION_BY_ID_SUCCESS:
      return actionReducer.getOrgByIdSuccess(state, action);
    case actionTypes.GET_ORGANIZATION_BY_ID_FAIL:
      return actionReducer.getOrgByIdFail(state, action);

    case actionTypes.CHANGE_ORGANIZATION_ACTIVATION:
      return actionReducer.changeOrgActivation(state, action);
    case actionTypes.CHANGE_ORGANIZATION_ACTIVATION_SUCCESS:
      return actionReducer.changeOrgActivationSuccess(state, action);
    case actionTypes.CHANGE_ORGANIZATION_ACTIVATION_FAIL:
      return actionReducer.changeOrgActivationFail(state, action);

    case actionTypes.CHANGE_TENANT_ACTIVATION:
      return actionReducer.changeTenantActivation(state, action);
    case actionTypes.CHANGE_TENANT_ACTIVATION_SUCCESS:
      return actionReducer.changeTenantActivationSuccess(state, action);
    case actionTypes.CHANGE_TENANT_ACTIVATION_FAIL:
      return actionReducer.changeTenantActivationFail(state, action);

    case actionTypes.DELETE_TENANT:
      return actionReducer.deleteTenant(state, action);
    case actionTypes.DELETE_TENANT_SUCCESS:
      return actionReducer.deleteTenantSuccess(state, action);
    case actionTypes.DELETE_TENANT_FAIL:
      return actionReducer.deleteTenantFail(state, action);

    case actionTypes.GET_TENANT_BY_ID:
      return actionReducer.getTenantById(state, action);
    case actionTypes.GET_TENANT_BY_ID_SUCCESS:
      return actionReducer.getTenantByIdSuccess(state, action);
    case actionTypes.GET_TENANT_BY_ID_FAIL:
      return actionReducer.getTenantByIdFail(state, action);

    case actionTypes.GET_ORGANIZATION_USER:
      return actionReducer.getOrganizationUser(state, action);
    case actionTypes.GET_ORGANIZATION_USER_SUCCESS:
      return actionReducer.getOrganizationUserSuccess(state, action);
    case actionTypes.GET_ORGANIZATION_USER_FAIL:
      return actionReducer.getOrganizationUserFail(state, action);

    case actionTypes.GET_TENANT_USER:
      return actionReducer.getTenantUser(state, action);
    case actionTypes.GET_TENANT_USER_SUCCESS:
      return actionReducer.getTenantUserSuccess(state, action);
    case actionTypes.GET_TENANT_USER_FAIL:
      return actionReducer.getTenantUserFail(state, action);

    case actionTypes.UPDATE_ORGANIZATION_USER:
      return actionReducer.updateOrgUser(state, action);
    case actionTypes.UPDATE_ORGANIZATION_USER_SUCCESS:
      return actionReducer.updateOrgUserSuccess(state, action);
    case actionTypes.UPDATE_ORGANIZATION_USER_FAIL:
      return actionReducer.updateOrgUserFail(state, action);

    case actionTypes.UPDATE_TENANT_USER:
      return actionReducer.updateTenantUser(state, action);
    case actionTypes.UPDATE_TENANT_USER_SUCCESS:
      return actionReducer.updateTenantUserSuccess(state, action);
    case actionTypes.UPDATE_TENANT_USER_FAIL:
      return actionReducer.updateTenantUserFail(state, action);

    case actionTypes.CHANGE_ORG_PASSWORD:
      return actionReducer.changeOrgPassword(state, action);
    case actionTypes.CHANGE_ORG_PASSWORD_SUCCESS:
      return actionReducer.changeOrgPasswordSuccess(state, action);
    case actionTypes.CHANGE_ORG_PASSWORD_FAIL:
      return actionReducer.changeOrgPasswordFail(state, action);

    case actionTypes.CHANGE_TENANT_PASSWORD:
      return actionReducer.changeTenantPassword(state, action);
    case actionTypes.CHANGE_TENANT_PASSWORD_SUCCESS:
      return actionReducer.changeTenantPasswordSuccess(state, action);
    case actionTypes.CHANGE_TENANT_PASSWORD_FAIL:
      return actionReducer.changeTenantPasswordFail(state, action);

    case actionTypes.GET_USER_TOKEN:
      return actionReducer.getUserToken(state, action);
    case actionTypes.GET_USER_TOKEN_SUCCESS:
      return actionReducer.getUserTokenSuccess(state, action);
    case actionTypes.GET_USER_TOKEN_FAIL:
      return actionReducer.getUserTokenFail(state, action);

    case actionTypes.GET_USER_TOKEN_BY_TENANT_ID:
      return actionReducer.getUserToken(state, action);

    case actionTypes.GET_ORGANIZATION_USAGE:
      return actionReducer.getOrganizationUsage(state, action);
    case actionTypes.GET_ORGANIZATION_USAGE_SUCCESS:
      return actionReducer.getOrganizationUsageSuccess(state, action);
    case actionTypes.GET_ORGANIZATION_USAGE_FAIL:
      return actionReducer.getOrganizationUsageFail(state, action);

    case actionTypes.GET_ORGANIZATIONS_USAGE:
      return actionReducer.getOrganizationsUsage(state, action);
    case actionTypes.GET_ORGANIZATIONS_USAGE_SUCCESS:
      return actionReducer.getOrganizationsUsageSuccess(state, action);
    case actionTypes.GET_ORGANIZATIONS_USAGE_FAIL:
      return actionReducer.getOrganizationsUsageFail(state, action);

    case actionTypes.DOWNLOAD_USAGE:
      return actionReducer.downloadUsage(state, action);
    case actionTypes.DOWNLOAD_USAGE_SUCCESS:
      return actionReducer.downloadUsageSuccess(state, action);
    case actionTypes.DOWNLOAD_USAGE_FAIL:
      return actionReducer.downloadUsageFail(state, action);

    case actionTypes.DOWNLOAD_EXCEL_FILE:
      return actionReducer.downloadExcelPlan(state, action);
    case actionTypes.DOWNLOAD_EXCEL_FILE_SUCCESS:
      return actionReducer.downloadExcelPlanSuccess(state, action);
    case actionTypes.DOWNLOAD_EXCEL_FILE_FAIL:
      return actionReducer.downloadExcelPlanFail(state, action);

    case actionTypes.SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE:
      return actionReducer.downloadOptimizePlan(state, action);
    case actionTypes.SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE_SUCCESS:
      return actionReducer.downloadOptimizePlanSuccess(state, action);
    case actionTypes.SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE_FAIL:
      return actionReducer.downloadOptimizePlanFail(state, action);

    case actionTypes.GET_ORG_POC:
      return actionReducer.getOrgPOC(state, action);
    case actionTypes.GET_ORG_POC_SUCCESS:
      return actionReducer.getOrgPOCSuccess(state, action);
    case actionTypes.GET_ORG_POC_FAIL:
      return actionReducer.getOrgPOCFail(state, action);

    case actionTypes.UPDATE_ORG_POC:
      return actionReducer.updateOrgPOC(state, action);
    case actionTypes.UPDATE_ORG_POC_SUCCESS:
      return actionReducer.updateOrgPOCSuccess(state, action);
    case actionTypes.UPDATE_ORG_POC_FAIL:
      return actionReducer.updateOrgPOCFail(state, action);

    case actionTypes.ADD_ORG_POC:
      return actionReducer.addOrgPOC(state, action);
    case actionTypes.ADD_ORG_POC_SUCCESS:
      return actionReducer.addOrgPOCSuccess(state, action);
    case actionTypes.ADD_ORG_POC_FAIL:
      return actionReducer.addOrgPOCFail(state, action);

    case actionTypes.REMOVE_ORG_POC:
      return actionReducer.removeOrgPOC(state, action);
    case actionTypes.REMOVE_ORG_POC_SUCCESS:
      return actionReducer.removeOrgPOCSuccess(state, action);
    case actionTypes.REMOVE_ORG_POC_FAIL:
      return actionReducer.removeOrgPOCFail(state, action);

    case actionTypes.GET_ORG_ADMINS:
      return actionReducer.getOrgAdmins(state, action);
    case actionTypes.GET_ORG_ADMINS_SUCCESS:
      return actionReducer.getOrgAdminsSuccess(state, action);
    case actionTypes.GET_ORG_ADMINS_FAIL:
      return actionReducer.getOrgAdminsFail(state, action);

    case actionTypes.ADD_ORG_ADMIN:
      return actionReducer.addOrgAdmin(state, action);
    case actionTypes.ADD_ORG_ADMIN_SUCCESS:
      return actionReducer.addOrgAdminSuccess(state, action);
    case actionTypes.ADD_ORG_ADMIN_FAIL:
      return actionReducer.addOrgAdminFail(state, action);

    case actionTypes.GET_ALL_PLANS:
      return actionReducer.getAllPlans(state, action);
    case actionTypes.GET_ALL_PLANS_SUCCESS:
      return actionReducer.getAllPlansSuccess(state, action);
    case actionTypes.GET_ALL_PLANS_FAIL:
      return actionReducer.getAllPlansFail(state, action);

    case actionTypes.SET_PLAN_STATUS:
      return actionReducer.setPlanStatus(state, action);
    case actionTypes.SET_PLAN_STATUS_SUCCESS:
      return actionReducer.setPlanStatusSuccess(state, action);
    case actionTypes.SET_PLAN_STATUS_FAIL:
      return actionReducer.setPlanStatusFail(state, action);

    case actionTypes.RESTORE_PLAN:
      return actionReducer.restorePlan(state, action);
    case actionTypes.RESTORE_PLAN_SUCCESS:
      return actionReducer.restorePlanSuccess(state, action);
    case actionTypes.RESTORE_PLAN_FAIL:
      return actionReducer.restorePlanFail(state, action);

    case actionTypes.SET_CUSTOM_SMS_LIST:
      return actionReducer.setCustomSms(state, action);
    case actionTypes.SET_CUSTOM_SMS_LIST_SUCCESS:
      return actionReducer.setCustomSmsSuccess(state, action);
    case actionTypes.SET_CUSTOM_SMS_LIST_FAIL:
      return actionReducer.setCustomSmsFail(state, action);

    case actionTypes.GET_CUSTOM_SMS_LIST:
      return actionReducer.getCustomSms(state, action);
    case actionTypes.GET_CUSTOM_SMS_LIST_SUCCESS:
      return actionReducer.getCustomSmsSuccess(state, action);
    case actionTypes.GET_CUSTOM_SMS_LIST_FAIL:
      return actionReducer.getCustomSmsFail(state, action);

    case actionTypes.GET_WEBHOOK_CONFIG:
      return actionReducer.getWebhookConfig(state, action);
    case actionTypes.GET_WEBHOOK_CONFIG_SUCCESS:
      return actionReducer.getWebhookConfigSuccess(state, action);
    case actionTypes.GET_WEBHOOK_CONFIG_FAIL:
      return actionReducer.getWebhookConfigFail(state, action);

    case actionTypes.SET_WEBHOOK_CONFIG:
      return actionReducer.setWebhookConfig(state, action);
    case actionTypes.SET_WEBHOOK_CONFIG_SUCCESS:
      return actionReducer.setWebhookConfigSuccess(state, action);
    case actionTypes.SET_WEBHOOK_CONFIG_FAIL:
      return actionReducer.setWebhookConfigFail(state, action);

    case actionTypes.GET_VERIFICATION_CODE_CONFIG:
      return actionReducer.getVerificationConfig(state, action);
    case actionTypes.GET_VERIFICATION_CODE_CONFIG_SUCCESS:
      return actionReducer.getVerificationConfigSuccess(state, action);
    case actionTypes.GET_VERIFICATION_CODE_CONFIG_FAIL:
      return actionReducer.getVerificationConfigFail(state, action);

    case actionTypes.SET_VERIFICATION_CODE_CONFIG:
      return actionReducer.setVerificationConfig(state, action);
    case actionTypes.SET_VERIFICATION_CODE_CONFIG_SUCCESS:
      return actionReducer.setVerificationConfigSuccess(state, action);
    case actionTypes.SET_VERIFICATION_CODE_CONFIG_FAIL:
      return actionReducer.setVerificationConfigFail(state, action);

    case actionTypes.CHANGE_USER_ACTIVATION:
      return actionReducer.changeUserActivation(state, action);
    case actionTypes.CHANGE_USER_ACTIVATION_SUCCESS:
      return actionReducer.changeUserActivationSuccess(state, action);
    case actionTypes.CHANGE_USER_ACTIVATION_FAIL:
      return actionReducer.changeUserActivationFail(state, action);

    case actionTypes.CREATE_TENANT_USER:
      return actionReducer.createTenantUser(state, action);
    case actionTypes.CREATE_TENANT_USER_SUCCESS:
      return actionReducer.createTenantUserSuccess(state, action);
    case actionTypes.CREATE_TENANT_USER_FAIL:
      return actionReducer.createTenantUserFail(state, action);

    case actionTypes.CREATE_ORG_USER:
      return actionReducer.createOrgUser(state, action);
    case actionTypes.CREATE_ORG_USER_SUCCESS:
      return actionReducer.createOrgUserSuccess(state, action);
    case actionTypes.CREATE_ORG_USER_FAIL:
      return actionReducer.createOrgUserFail(state, action);

    case actionTypes.GET_ROLE_FLAG:
      return actionReducer.getRoleFlag(state, action);
    case actionTypes.GET_ROLE_FLAG_SUCCESS:
      return actionReducer.getRoleFlagSuccess(state, action);
    case actionTypes.GET_ROLE_FLAG_FAIL:
      return actionReducer.getRoleFlagFail(state, action);

    case actionTypes.GET_ORG_ROLE_FLAG:
      return actionReducer.getOrgRoleFlag(state, action);
    case actionTypes.GET_ORG_ROLE_FLAG_SUCCESS:
      return actionReducer.getOrgRoleFlagSuccess(state, action);
    case actionTypes.GET_ORG_ROLE_FLAG_FAIL:
      return actionReducer.getOrgRoleFlagFail(state, action);

    case actionTypes.GET_ALL_TENANT_USERS:
      return actionReducer.getAllTenantUsers(state, action);
    case actionTypes.GET_ALL_TENANT_USERS_SUCCESS:
      return actionReducer.getAllTenantUsersSuccess(state, action);
    case actionTypes.GET_ALL_TENANT_USERS_FAIL:
      return actionReducer.getAllTenantUsersFail(state, action);

    case actionTypes.GET_ALL_ORG_USERS:
      return actionReducer.getAllOrgUsers(state, action);
    case actionTypes.GET_ALL_ORG_USERS_SUCCESS:
      return actionReducer.getAllOrgUsersSuccess(state, action);
    case actionTypes.GET_ALL_ORG_USERS_FAIL:
      return actionReducer.getAllOrgUsersFail(state, action);

    case actionTypes.GET_USER_BY_ID:
      return actionReducer.getUserOfTenant(state, action);
    case actionTypes.GET_USER_BY_ID_SUCCESS:
      return actionReducer.getUserOfTenantSuccess(state, action);
    case actionTypes.GET_USER_BY_ID_FAIL:
      return actionReducer.getUserOfTenantFail(state, action);

    case actionTypes.GET_MISSION_REASON:
      return actionReducer.getMissionReason(state, action);
    case actionTypes.GET_MISSION_REASON_SUCCESS:
      return actionReducer.getMissionReasonSuccess(state, action);
    case actionTypes.GET_MISSION_REASON_FAIL:
      return actionReducer.getMissionReasonFail(state, action);

    case actionTypes.ADD_MISSION_REASON:
      return actionReducer.addMissionReason(state, action);
    case actionTypes.ADD_MISSION_REASON_SUCCESS:
      return actionReducer.addMissionReasonSuccess(state, action);
    case actionTypes.ADD_MISSION_REASON_FAIL:
      return actionReducer.addMissionReasonFail(state, action);

    case actionTypes.UPDATE_MISSION_REASON:
      return actionReducer.deleteMissionReason(state, action);
    case actionTypes.UPDATE_MISSION_REASON_SUCCESS:
      return actionReducer.deleteMissionReasonSuccess(state, action);
    case actionTypes.UPDATE_MISSION_REASON_FAIL:
      return actionReducer.deleteMissionReasonFail(state, action);

    case actionTypes.DELETE_MISSION_REASON:
      return actionReducer.updateMissionReason(state, action);
    case actionTypes.DELETE_MISSION_REASON_SUCCESS:
      return actionReducer.updateMissionReasonSuccess(state, action);
    case actionTypes.DELETE_MISSION_REASON_FAIL:
      return actionReducer.updateMissionReasonFail(state, action);

    case actionTypes.CHANGE_USER_PASSWORD:
      return actionReducer.changeUserPassword(state, action);
    case actionTypes.CHANGE_USER_PASSWORD_SUCCESS:
      return actionReducer.changeUserPasswordSuccess(state, action);
    case actionTypes.CHANGE_USER_PASSWORD_FAIL:
      return actionReducer.changeUserPasswordFail(state, action);

    case actionTypes.Get_ROLE_ORGS:
      return actionReducer.getRoleOrgs(state, action);
    case actionTypes.Get_ROLE_ORGS_SUCCESS:
      return actionReducer.getRoleOrgsSuccess(state, action);
    case actionTypes.Get_ROLE_ORGS_FAIL:
      return actionReducer.getRoleOrgsFail(state, action);

    case actionTypes.GET_ORG_LIST_ID:
      return actionReducer.getOrgsListId(state, action);
    case actionTypes.GET_ORG_LIST_ID_SUCCESS:
      return actionReducer.getOrgsListIdSuccess(state, action);
    case actionTypes.GET_ORG_LIST_ID_FAIL:
      return actionReducer.getOrgsListIdFail(state, action);

    case actionTypes.ADD_ROLE:
      return actionReducer.addRole(state, action);
    case actionTypes.ADD_ROLE_SUCCESS:
      return actionReducer.addRoleSuccess(state, action);
    case actionTypes.ADD_ROLE_FAIL:
      return actionReducer.addRoleFail(state, action);

    case actionTypes.DELETE_ROLE:
      return actionReducer.deleteRole(state, action);
    case actionTypes.DELETE_ROLE_SUCCESS:
      return actionReducer.deleteRoleSuccess(state, action);
    case actionTypes.DELETE_ROLE_FAIL:
      return actionReducer.deleteRoleFail(state, action);

    case actionTypes.EDIT_ROLE:
      return actionReducer.editRole(state, action);
    case actionTypes.EDIT_ROLE_SUCCESS:
      return actionReducer.editRoleSuccess(state, action);
    case actionTypes.EDIT_ROLE_FAIL:
      return actionReducer.editRoleFail(state, action);

    case actionTypes.GET_ALL_ROLES:
      return actionReducer.getAllRoles(state, action);
    case actionTypes.GET_ALL_ROLES_SUCCESS:
      return actionReducer.getAllRolesSuccess(state, action);
    case actionTypes.GET_ALL_ROLES_FAIL:
      return actionReducer.getAllRolesFail(state, action);

    case actionTypes.GET_ROLE_BY_ID:
      return actionReducer.getRolesById(state, action);
    case actionTypes.GET_ROLE_BY_ID_SUCCESS:
      return actionReducer.getRolesByIdSuccess(state, action);
    case actionTypes.GET_ROLE_BY_ID_FAIL:
      return actionReducer.getRolesByIdFail(state, action);

    case actionTypes.GET_MENU:
      return actionReducer.getMenu(state, action);
    case actionTypes.GET_MENU_SUCCESS:
      return actionReducer.getMenuSuccess(state, action);
    case actionTypes.GET_MENU_FAIL:
      return actionReducer.getMenuFail(state, action);

    case actionTypes.GET_ACTION:
      return actionReducer.getAction(state, action);
    case actionTypes.GET_ACTION_SUCCESS:
      return actionReducer.getActionSuccess(state, action);
    case actionTypes.GET_ACTION_FAIL:
      return actionReducer.getActionFail(state, action);

    case actionTypes.GET_PLAN_LOGS_SUPERADMIN:
      return actionReducer.getLogs(state, action);
    case actionTypes.GET_PLAN_LOGS_SUPERADMIN_SUCCESS:
      return actionReducer.getLogsSuccess(state, action);
    case actionTypes.GET_PLAN_LOGS_SUPERADMIN_FAIL:
      return actionReducer.getLogsFail(state, action);

    case actionTypes.ROLE_MODIFY_ACTIONS:
      return actionReducer.RoleModify(state, action);

    case actionTypes.GET_ALL_CONTRACTS:
      return actionReducer.getAllContracts(state, action);
    case actionTypes.GET_ALL_CONTRACTS_SUCCESS:
      return actionReducer.getAllContractsSuccess(state, action);
    case actionTypes.GET_ALL_CONTRACTS_FAIL:
      return actionReducer.getAllContractsFail(state, action);

    case actionTypes.ADD_CONTRACT:
      return actionReducer.addContract(state, action);
    case actionTypes.ADD_CONTRACT_SUCCESS:
      return actionReducer.addContractSuccess(state, action);
    case actionTypes.ADD_CONTRACT_FAIL:
      return actionReducer.addContractFail(state, action);

    case actionTypes.DELETE_CONTRACT:
      return actionReducer.deleteContract(state, action);
    case actionTypes.DELETE_CONTRACT_SUCCESS:
      return actionReducer.deleteContractSuccess(state, action);
    case actionTypes.DELETE_CONTRACT_FAIL:
      return actionReducer.deleteContractFail(state, action);

    case actionTypes.EDIT_CONTRACT:
      return actionReducer.editContract(state, action);
    case actionTypes.EDIT_CONTRACT_SUCCESS:
      return actionReducer.editContractSuccess(state, action);
    case actionTypes.EDIT_CONTRACT_FAIL:
      return actionReducer.editContractFail(state, action);

    case actionTypes.GET_ACCOUNT_USAGE:
      return actionReducer.getAccountUsage(state, action);
    case actionTypes.GET_ACCOUNT_USAGE_SUCCESS:
      return actionReducer.getAccountUsageSuccess(state, action);
    case actionTypes.GET_ACCOUNT_USAGE_FAIL:
      return actionReducer.getAccountUsageFail(state, action);

    case actionTypes.CREATE_APP_VERSION:
      return actionReducer.createAppVersion(state, action);
    case actionTypes.CREATE_APP_VERSION_SUCCESS:
      return actionReducer.createAppVersionSuccess(state, action);
    case actionTypes.CREATE_APP_VERSION_FAIL:
      return actionReducer.createAppVersionFail(state, action);

    default:
      return state;
  }
};
